import { state, style, transition, animate, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICFeedItem } from '../models/ic/ic-feed-item';
import { Subscription } from 'rxjs';
import { ICService } from '../services/ic.service';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { ICTipoFeedItem, IntervaloAbsoluto, ModeloDeEstatistica, TipoDeEstatistica } from '../models/enum';
import { EstatisticaSintetica } from '../models/estatistica-sintetica';
import { EstatisticaService } from '../services/estatistica.service';
import { IntervaloDeTempoService } from '../services/intervalo-de-tempo.service';
import { IntervaloDeTempo } from '../models/intervalo-de-tempo';
import { UsuarioLogado } from '../models/usuario-logado';
import { GlobalService } from '../services/global.service';
import { Configuracao } from '../models/configuracao';
import { UtilitarioService } from '../services/utilitario.service';

@Component({
  selector: 'app-icnavbar',
  templateUrl: './icnavbar.component.html',
  styleUrls: ['./icnavbar.component.scss'],
  animations: [
    trigger('flipState', [
      state('active', style({
        transform: 'rotateX(179deg)'
      })),
      state('inactive', style({
        transform: 'rotateX(0)'
      })),
      transition('active => inactive', animate('500ms ease-out')),
      transition('inactive => active', animate('500ms ease-in'))
    ])
  ]
})
export class ICNavbarComponent implements OnInit, OnDestroy {

  private novoICFeedItemSubscription$: Subscription;

  intervaloDeTempo: IntervaloDeTempo = new IntervaloDeTempo();

  estatisticasLogin =
    [
      { icone: 'person', cor: 'text-success', valor: 100, tooltip: 'Integradores online' },
      { icone: 'person', cor: 'text-danger', valor: 10, tooltip: 'Integradores offline' }
    ];

  estatisticas =
    [
      { modelo: ModeloDeEstatistica.Simulacoes, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'content_paste_search', cor: 'text-secondary', tooltip: 'Simulações do dia' },
      { modelo: ModeloDeEstatistica.Orcamentos, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'assignment', cor: 'text-info', tooltip: 'Orçamentos do dia' },
      { modelo: ModeloDeEstatistica.Pedidos, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'assignment_turned_in', cor: 'text-primary', tooltip: 'Pedidos do dia' }
    ];

  feedAnterior: ICFeedItem;
  feedProximo: ICFeedItem;

  flip: string = 'active';

  usuarioLogado: UsuarioLogado;

  idVisual: any;

  constructor(private router: Router, private notificacaoService: NotificacaoService,
    private iCService: ICService, private estatisticaService: EstatisticaService,
    private intervaloDeTempoService: IntervaloDeTempoService, private globalService: GlobalService,
    private utilitarioService: UtilitarioService) {
    this.idVisual = JSON.parse(localStorage.getItem('idVisual'));
  }

  async ngOnInit() {

    const cores = this.utilitarioService.generateShades(this.idVisual.cores.corPrimary, 8);

    for (let index = 0; index < this.estatisticas.length; index++) {
      this.estatisticas[index].cor = cores[index];
    }

    this.usuarioLogado = await this.globalService.consultaUsuario();
    await this.buscarIntervaloDeTempo();

    this.buscarEstatisticasLogin();
    this.buscarEstatisticas(this.estatisticas);


    this.novoICFeedItemSubscription$ = this.notificacaoService.novoICFeedItem.subscribe(data => {

      if (data === null || data === undefined || data.exibirNoFeed) {

        const novoFeedItem = this.iCService.buscarFeedItemMaisRecente();

        if (novoFeedItem !== undefined && novoFeedItem !== null) {
          if (this.feedAnterior === null || this.feedAnterior === undefined) {
            this.feedAnterior = novoFeedItem;
            this.feedProximo = null;
          } else {
            this.feedProximo = novoFeedItem;
            this.feedAnterior = null;
          }

          this.toggleFlip();
        }
      }

      if (data !== null && data !== undefined) {
        switch (data.tipo) {
          case ICTipoFeedItem.Login:
          case ICTipoFeedItem.Logout:
            this.buscarEstatisticasLogin();
            break;

          case ICTipoFeedItem.NovoIntegrador:
          case ICTipoFeedItem.PerdeuIntegrador:
            this.buscarEstatisticasLogin();
            this.buscarEstatisticas(this.estatisticas.filter(p => p.modelo === ModeloDeEstatistica.Orcamentos));
            this.buscarEstatisticas(this.estatisticas.filter(p => p.modelo === ModeloDeEstatistica.Pedidos));
            this.buscarEstatisticas(this.estatisticas.filter(p => p.modelo === ModeloDeEstatistica.Simulacoes));
            break;


          case ICTipoFeedItem.NovoOrcamento:
          case ICTipoFeedItem.NovoPedido:
          case ICTipoFeedItem.ConfirmouPedido:
          case ICTipoFeedItem.EditouOrcamento:
          case ICTipoFeedItem.EditouPedido:
            this.buscarEstatisticas(this.estatisticas.filter(p => p.modelo === ModeloDeEstatistica.Orcamentos));
            this.buscarEstatisticas(this.estatisticas.filter(p => p.modelo === ModeloDeEstatistica.Pedidos));
            break;

          case ICTipoFeedItem.NovaSimulacao:
            this.buscarEstatisticas(this.estatisticas.filter(p => p.modelo === ModeloDeEstatistica.Simulacoes));
            break;

          default:
            break;
        }
      }

    });
  }

  async buscarIntervaloDeTempo() {
    try {
      this.intervaloDeTempo = await this.intervaloDeTempoService.consultarIntervaloDeTempoAbsoluto(IntervaloAbsoluto.Hoje).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
    }
  }

  toggleFlip() {
    this.flip = (this.flip == 'inactive') ? 'active' : 'inactive';
  }

  irParaFeed() {
    this.router.navigate(['feed-integradores']);
  }

  buscarEstatisticas(estatisticas) {
    estatisticas.forEach(p => {
      this.buscarEstatistica(p);
      if (p.subs !== null && p.subs !== undefined && p.subs.length > 0) {
        this.buscarEstatisticas(p.subs);
      }
    });
  }

  buscarEstatistica(estatistica) {
    this.estatisticaService.consultarEstatisticaSintetica(estatistica.modelo, estatistica.tipo,
      this.intervaloDeTempo.dataHoraInicio, this.intervaloDeTempo.dataHoraTermino, null, this.usuarioLogado.id, null).subscribe(
        (f) => {
          estatistica.estatistica = f;
        },
        (erro) => {
        }
      );
  }

  buscarEstatisticasLogin() {
    this.iCService.buscarQtdIntegradoresOnline().subscribe(
      (qtd) => {
        this.estatisticasLogin[0].valor = qtd;
      },
      (erro) => {
      }
    );

    this.iCService.buscarQtdIntegradoresOffline().subscribe(
      (qtd) => {
        this.estatisticasLogin[1].valor = qtd;
      },
      (erro) => {
      }
    );
  }

  ngOnDestroy(): void {
    if (this.novoICFeedItemSubscription$ !== null && this.novoICFeedItemSubscription$ !== undefined) {
      this.novoICFeedItemSubscription$.unsubscribe();
    }
  }

}
